/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{-webkit-box-flex:1;flex:1;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:start;align-items:flex-start}@media screen and (min-width:768px){[_nghost-%COMP%]{-webkit-box-align:center;align-items:center}}"];
export { styles as styles };
//# sourceMappingURL=recovery-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/login/recovery-page/recovery-page.component.scss.shim.ngstyle.js
// module id = 1669
// module chunks = 27 28 29